import { shapeHit, snapshotValueEqual, type Shape } from '@vd/annotation-core';

/**
 * Resolve Escape or capture-loss cancellation against collaboration that
 * arrived after the drag began. A previously unsynced local shape remains
 * local-first; otherwise cancellation reveals the newest server shape.
 */
export function cancelledDragShape(
  startShape: Shape,
  startBaseShape: Shape | undefined,
  latestBaseShape: Shape | undefined,
  serverChanged: boolean,
): Shape | null {
  if (!serverChanged || startBaseShape === undefined) return startShape;
  if (!snapshotValueEqual(startShape, startBaseShape)) return startShape;
  return latestBaseShape ?? null;
}

/** Detect both versioned and rolling-version API changes to a drag's base. */
export function dragBaseChanged(
  startVersion: number,
  latestVersion: number,
  startBaseShape: Shape | undefined,
  latestBaseShape: Shape | undefined,
): boolean {
  return startVersion !== latestVersion || !snapshotValueEqual(startBaseShape, latestBaseShape);
}

/**
 * Return the topmost rendered shape at a natural-coordinate point.
 * Shapes paint in array order, so selection must scan in reverse or a
 * covered lower-stack pin can steal the click from the visible annotation.
 */
export function topmostHitShape(
  shapes: Shape[],
  imageId: string,
  x: number,
  y: number,
): Shape | undefined {
  for (let index = shapes.length - 1; index >= 0; index -= 1) {
    const shape = shapes[index]!;
    if (shape.imageId !== imageId) continue;
    if (shapeHit(shape, x, y)) return shape;
  }
  return undefined;
}
